var site = site || {};
var Mustache = Mustache || {};
var Model = Model || {};

(function($){

  /**
    * The doors panel class handles all functionality for the in-store locator doors panel.
    * This includes the rendering of the door and door row templates along with also adding the functionality.
    * NOTE: The door data itself isn't called here but in the model doors_inventory.
    * The event 'DoorsInventory:query:success' is used to collect that data before display rendering is started.
    * Door helper events are also set here, so before adding additional functionality, please see what is available.
  */
  site.doors = function(args) {
    var _args = args || {};
    this.dom = {};
    this.container = _args.container || null;
    this.doorData = null;
    this.activeSku = null;
    this.eventNameSpace = 'doors:';
    this.useOverlay = false;

    this.bindEvents();
  };

  /**
    * Method to get all DOM selectors when class is initialized.
    * All selectors should be placed here to keep everything located in one spot.
  */
  site.doors.prototype.getNodes = function() {
    this.dom.$doorContainer = $('.js-product-doors');
    this.dom.$doorContainerOverlay = $('.js-product-doors-overlay');
    this.dom.$storeDoorsContainer = $('.js-doors-stores', this.dom.$doorContainer);
    this.dom.$storeDoorsContainerOverlay = $('.js-doors-stores', this.dom.$doorContainerOverlay);
    this.dom.$partnerDoorsContainer = $('.js-doors-partners');
    this.dom.$ContainerAvailableDoors = $('.js-inline-container__available--doors');
    this.dom.$ContainerAvailableDoorsOverlay = $('.js-inline-container__available--doors-overlay');
    this.dom.$storecheckcontainer = $('.js-store-check-inline');
    this.dom.$overlayContainer = $('.js-store-check-overlay');

  };

  /**
    * Class method to define the DOM classes needed in the doors panel.
    * These classes are specific to elements that will be rendered multiple times and can't
    *   be placed in the getNodes method.
    * These mainly deal with the js classes for the inventory messaging on each door.
  */
  site.doors.prototype.nodeClass = {
    activeClass : 'display',
    doorResultsCount : '.js-door-results-count',
  };


  /**
    * Method to set all bind events when class is initialized.
    * All bind events, including events from other panels, should be placed here.
  */
  site.doors.prototype.bindEvents = function() {
    $(document).on(this.eventNameSpace + 'renderDoorTable', $.proxy(this.renderDoorTable, this));
    $(document).on(this.eventNameSpace + 'renderTableRows', $.proxy(this.renderTableRows, this));
    $(document).on(this.eventNameSpace + 'renderDoorRow', $.proxy(this.renderDoorRow, this));
    $(document).on(this.eventNameSpace + 'showAllDoorRows', $.proxy(this.showAllDoorRows, this));
    $(document).on(this.eventNameSpace + 'setDoorEvents', $.proxy(this.setDoorEvents, this));
    $(document).on(this.eventNameSpace + 'setDoorEventsInline', $.proxy(this.setDoorEventsInline, this));
    $(document).on(this.eventNameSpace + 'loadDoors', $.proxy(this.loadDoors, this));
    $(document).on(this.eventNameSpace + 'sendDoorInfo', $.proxy(this.sendDoorInfo, this));
    $(document).on(this.eventNameSpace + 'openNativeMap', $.proxy(this.openNativeMap, this));
    $(document).on(this.eventNameSpace + 'updateDoorData', $.proxy(this.updateDoorData, this));
    $(document).on(this.eventNameSpace + 'renderTableRows:complete', $.proxy(this.onResultsUpdate, this));
    $(document).on(this.eventNameSpace + 'clear', $.proxy(this.clear, this));

    $(document).on('inStoreLocator:launched', $.proxy(this.init, this));
    $(document).on('display:device:set', $.proxy(this.setDeviceFlag, this));
    $(document).on('display:overlay:use', $.proxy(this.setOverlayFlag, this));
    $(document).on('inStoreLocator:reset', $.proxy(this.removeEvents, this));
    $(document).on('MPP:quickshopsDestroyed', $.proxy(this.removeEvents, this));
    $(document).on('product.skuSelect', $.proxy(this.setActiveSku, this));
    $(document).on('sku:select', $.proxy(this.setActiveSku, this));
    $(document).on('display:sku:set', $.proxy(this.setActiveSku, this));
    $(document).on('display:loaded:set', $.proxy(this.setLoaded, this));
    $(document).on('display:loaded:unset', $.proxy(this.unsetLoaded, this));
    $(document).on('controls:currentZipCode', $.proxy(this.setZipCode, this));
    $(document).on('DoorsInventory:query:success', $.proxy(this.updateDoorData, this));
  };


  /**
    * Initialization method called when the locator is displayed inline and in an overlay.
    * Any class methods that need to be called after the locator is displayed, should be here.
  */
  site.doors.prototype.init = function() {
    this.getNodes();
  };


  /**
    * Helper method used to determine if a door is a brand store.
    * Uses the door name to see if the word 'origin' is available.
    * Work around till additional door data is added that can be better used to determine this.
  */
  site.doors.prototype.isBrandDoor = function( door ) {
    var doorName = ( door && door.DOORNAME ) ? door.DOORNAME : null;
    if ( doorName ) {
      var isBrandDoor = doorName.match(/origin/gi);
      return isBrandDoor ? true : false;
    } else {
      return null;
    }
  };


  /**
    * Method responsible for rendering the doors_container template and inserting into the DOM.
    * Has an optional callback argement you can use if you need to make sure rendering has happened before proceeding.
    * Uses the dom node that.dom.$doorContainer defined in the getNodes method as the container.
  */
  site.doors.prototype.renderDoorTable = function(e, args) {

    var that = this;
    var _args = args || {};
    var _callback = _args.callback || null;

    that.getNodes();

    var _container = (this.useOverlay && this.isLoaded) ? this.dom.$doorContainerOverlay : this.dom.$doorContainer;

    var _inlineTemplate = $("script.inline-template[path='product_store_check/doors_container']").html();

    _container.html(_inlineTemplate);

    if ( _callback ) {
      _callback(html);
    }
  };


  /**
    * Method that handles inserting the door html into the door table templates.
    * First, it collects the doorData passed from the doors_inventory Model.
    * Then it iterates through the sorted doors and calls 'doors:renderDoorRow' to handle rendering.
    * It also checks the door inventory data via Model.DoorsInventory and updates the door data.
    * Once completed, the event 'doors:renderTableRows:complete' is fired.
  */
  site.doors.prototype.renderTableRows = function(e, args) {
    var that = this;

    that.getNodes();

    var _args = args || {};
    var _callback = _args.callback || null;
    var _doorData = _args.doorData ? _args.doorData : that.doorData ? that.doorData.sorted : null;
    _doorData = _args.availOnly ? that.filterAvailDoorData({ data: _doorData }) : _doorData ? _doorData : [];
    var _limit = _args.limit || _doorData.length;
    var _distance = _args.distance || null;
    var _hideAvailMsg = _args.hideAvailMsg || false;

    if (!_doorData || _doorData.length <= 0) {
      return null;
    }

    var storeDoors = [];
    for (var i = 0; i < _limit; i++) {

      var door = $.extend({}, _doorData[i]);

      if (door.distance_short && parseInt(door.distance_short) > parseInt(_distance)) {
        continue;
      }

      storeDoors.push(door);
      door.hideAvailMsg = _hideAvailMsg;

      var $container = (that.useOverlay && that.isLoaded) ? that.dom.$storeDoorsContainerOverlay : that.dom.$storeDoorsContainer;
      var $storecheckcontainer = this.dom.$storecheckcontainer;
      var $overlayContainer = this.dom.$overlayContainer;

      // Add class used to hide the not available messaging per row.
      if ( !$container.hasClass('doors-avail') ) {
        $container.addClass('doors-avail');
         if( $storecheckcontainer.hasClass('psc-state-stores') || $overlayContainer.hasClass('psc-state-overlay') ){
          that.dom.$ContainerAvailableDoors.removeClass('hidden');
          that.dom.$ContainerAvailableDoorsOverlay.removeClass('hidden');
        }
    }

      // Check for stock info.
      var doorSkuArg = {
        doorId : door.DOOR_ID,
        skuId : that.activeSku
      };

      var inventoryData = Model.DoorsInventory ? Model.DoorsInventory.getDoorSkuInventoryData( doorSkuArg ) : null;
      if ( inventoryData !== null ) {
        door = $.extend(door, inventoryData);
        door.hasInventoryData = 1;
      }
      $(document).trigger(that.eventNameSpace + 'renderDoorRow', {
        doorData : door,
        container : $container,
        callback : function(html) {
          if ( _callback ) {
            _callback({
              door : door,
              html : html
            });
          }
        }
      });
    };

    $(document).trigger(that.eventNameSpace + 'renderTableRows:complete', { data: storeDoors });
  };


  /**
    * Method that handles rendering the door_row mustache template and placing it in the container div argument.
    * It requires a single door data and a div to place to rendered door row in.
    * Also has optional backback, returning the container w/ door row, if anything else is needed after rendering.
  */
  site.doors.prototype.renderDoorRow = function(e, args) {
    var _doorData = args.doorData;
    var _container = args.container;
    var _callback = args.callback;

    if (!_doorData || !_container) {
      return null;
    }

    var _inlineTemplate = $("script.inline-template[path='product_store_check/door_row']").html();
    var _doorRow = Mustache.render(_inlineTemplate, _doorData);

    _container.append(_doorRow);
    _callback( _container );
  };


  /**
    * Method that sets the individual door action events.
    * After passing the door data and rows container html, it will
    *   add the individual click events to the door.
    * The events added included are showing the door info window on door click, direction buttons
    *   and send door info functionality.
    * Each event uses the different trigger events for the different panel classes.
  */
  site.doors.prototype.setDoorEvents = function(e, args) {
    var that = this;

    var door = args.door;
    var rowsContainer = args.html;

    var $doorRow  = $('.js-door-' + door.DOOR_ID, rowsContainer);
    var $doorInfo = $('.js-door-info', $doorRow);

    var $doorDirectionsBtn = $('.js-store-directions', $doorRow);
    $doorDirectionsBtn.click(function(e) {
      e.preventDefault();

      $(document).trigger('map:setDirections', {
        door : door,
        start : that.doorData.latitude + ',' + that.doorData.longitude
      });
    });
    
  };


  /**
    * Method that sets the individual door action events for inline in-store locator.
    * After passing the door data and rows container html, it will
    *   add the individual click events to the door similar to the setDoorEvents method.
    * The events added include are opening the native browser to show the door and email the store info.
  */
  site.doors.prototype.setDoorEventsInline = function(e, args) {
    var that = this;

    var door = args.door;
    var rowsContainer = args.html;

    var $doorRow  = $('.js-door-' + door.DOOR_ID, rowsContainer);

    var $doorDirectionsBtn = $('.js-store-directions', $doorRow);
    $doorDirectionsBtn.click(function(e) {
      e.preventDefault();
      $(document).trigger(that.eventNameSpace + 'openNativeMap', { door: door });
    });
  };


  /**
    * Method that handles hidding a door row within the door table.
  */
  site.doors.prototype.filterAvailDoorData = function(args) {
    var that = this;

    var _args = args || {};
    var _skuId = _args.skuId;
    var _doorData = _args.data ? _args.data : (that.doorData && that.doorData.results) ? that.doorData.results : null;
    var _filteredData = [];

    if ( !_doorData || !Model.DoorsInventory ) {
      return null;
    }

    for (var id in _doorData) {
      var door = ( _doorData && _doorData[id] ) ? _doorData[id] : null;
      var inStock = Model.DoorsInventory.isDoorSkuInStock({
        skuId : that.activeSku,
        doorId : door && door.DOOR_ID ? door.DOOR_ID : null
      });
      if (inStock) {
        _filteredData.push(door);
      }
    };

    return _filteredData;
  };


  /**
    * Method that handles showing all door rows within the door table.
    * It iterates through the doorData results and makes sure all door rows are displayed.
    * You can also call this method with the event 'doors:showAllDoorRows'.
  */
  site.doors.prototype.showAllDoorRows = function(e, args) {
    var that = this;

    var _args = args || {};
    var skuId = _args.skuId;
    var doorData = (that.doorData && that.doorData.results) ? that.doorData.results : null;

    if ( !doorData ) {
      return null;
    }

    // Show only stores that have the sku in-stock.
    var rowsArray = that.dom.$doorContainer.find('[class*="js-door"]');
    rowsArray.each(function(i, row) {
      var doorId = $(row).data('door-id');
      if (doorId) {
        var door = ( doorData && doorData[doorId] ) ? doorData[doorId] : null;

        if ( door ) {
          $(row).show();
          $(document).trigger('map:showMarkers', door.idx);
        }
      }
    });

  };


  /**
    * Method that handles calling google maps using the passed door data.
    * Mostly used for mobile but could be tied to other scenarios.
    * You can call this method via the 'doors:openNativeMap' event.
  */
  site.doors.prototype.openNativeMap = function(e, args) {
    var _args = args || {};
    var doorData = _args.door;

    if ( !doorData || $.isEmptyObject(doorData) ) {
      return null;
    }

    window.open("https://maps.google.com/?li=" + doorData.LATITUDE + "," + doorData.LONGITUDE + "&q=" + doorData.DOORNAME, "_blank");

    return null;    
  };


  /**
    * Method that handles the toggling of the send door info input fields.
    * When a doorRow node is passed, it either adds or removes the activeClass to display the fields.
  */
  site.doors.prototype.toggleDoorSendInfo = function(e, args) {
    var that = this;
    var $doorRow = args.doorRow;

    var $emailContainer = $(that.nodeClass.emailStoreContainer, $doorRow);
    if ( $emailContainer.hasClass(that.nodeClass.activeClass) ) {
      $emailContainer.removeClass(that.nodeClass.activeClass);
    } else {
      $emailContainer.addClass(that.nodeClass.activeClass);
    }
  };


  /**
    * Method responsible for updating the internal var this.doorData.
    * This is tied to the Model DoorsInventory success event 'DoorsInventory:query:success' so
    *   once that query is called, this listens in to make sure the latest data is 
    *   available next time door rendering is needed.
  */
  site.doors.prototype.updateDoorData = function(e, data) {
    this.doorData = data;
  };


  /**
    * Method responsible for handling any post result changes.
    * Happens after a door inventory query is made and looks to this.doorData for latest data.
  */
  site.doors.prototype.onResultsUpdate = function(e, args) {
    var _args = args || {};

    var count = 0;
    if (_args.data) {
      count = _args.data.length;
    } else {
      count = ( this.doorData && this.doorData.sorted ) ? this.doorData.sorted.length.toString() : null;
    }
    if (count) {
      $(this.nodeClass.doorResultsCount).html(count);
  }
  };


  /**
    * Method responsible for updating the internal var this.currentZipCode.
    * This is tied to the success event 'controls:currentZipCode' so 
    *   anytime the zipcode is changed, this listens in to make sure the latest zip code.
  */
  site.doors.prototype.setZipCode = function(e, zip) {
    this.currentZipCode = zip;
  };


  /**
    * Method responsible for updating the internal var this.activeSku.
    * This is used by both events 'product:sku:change' and 'sku:select' so 
    *   anytime the sku in inventory is changed, this listens in to make it has the latest.
  */
  site.doors.prototype.setActiveSku = function(e, sku) {
    this.activeSku = ( typeof sku === 'object' && sku.SKU_BASE_ID ) ? sku.SKU_BASE_ID : sku;
  };


  site.doors.prototype.setOverlayFlag = function(e, args) {
    this.useOverlay = true;
  };

  /**
    * Method used to set the global isLoaded flag.
    * isLoaded is used to determine if the user has loaded the app.
    * In certain scenarios, the initial load needs to be handle differently then subsequent actions.
  */
  site.doors.prototype.setLoaded = function() {
    this.isLoaded = true;
  };

  /**
    * Method used to unset the global isLoaded flag.
  */
  site.doors.prototype.unsetLoaded = function() {
    this.isLoaded = false;
  };


  site.doors.prototype.clear = function() {
    var _container = this.useOverlay ? this.dom.$doorContainerOverlay : this.dom.$doorContainer;
    if (_container) {
      _container.html('');
    }
  };

  /**
    * Method to unbind all events associated to document.
    * Calls the inStoreLocator event removeEvents passing the current namespace.
  */
  site.doors.prototype.removeEvents = function(e) {
    var that = this;
    $(document).trigger('inStoreLocator:removeEvents', {
      nameSpace : that.eventNameSpace
    });
  };

})(jQuery);